import { render, staticRenderFns } from "./DashboardTestfields.vue?vue&type=template&id=0bf71160&scoped=true"
import script from "./DashboardTestfields.vue?vue&type=script&lang=js"
export * from "./DashboardTestfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf71160",
  null
  
)

export default component.exports